import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addPropertyResaleVibe = (vibeData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_PROPERTY_RESALE_VIBE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale-vibe/add`,
        vibeData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_PROPERTY_RESALE_VIBE_SUCCESS", payload: data });
        toast.success("Property resale vibe added successfully!");
      } else {
        dispatch({ type: "ADD_PROPERTY_RESALE_VIBE_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "ADD_PROPERTY_RESALE_VIBE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listPropertyResaleVibe = (pageData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_PROPERTY_RESALE_VIBE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale-vibe/list`,
        pageData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_PROPERTY_RESALE_VIBE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_PROPERTY_RESALE_VIBE_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "LIST_PROPERTY_RESALE_VIBE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewPropertyResaleVibe = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_PROPERTY_RESALE_VIBE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/property-resale-vibe/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_PROPERTY_RESALE_VIBE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_PROPERTY_RESALE_VIBE_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "VIEW_PROPERTY_RESALE_VIBE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updatePropertyResaleVibe = (vibeData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_PROPERTY_RESALE_VIBE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale-vibe/update`,
        vibeData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_PROPERTY_RESALE_VIBE_SUCCESS", payload: data });
        toast.success("Property resale vibe updated successfully!");
      } else {
        dispatch({ type: "UPDATE_PROPERTY_RESALE_VIBE_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_PROPERTY_RESALE_VIBE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updatePropertyResaleVibeStatus = (statusData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_PROPERTY_RESALE_VIBE_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale-vibe/status-update`,
        statusData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_PROPERTY_RESALE_VIBE_STATUS_SUCCESS",
          payload: data,
        });
        toast.success(data?.message || "Status updated successfully!");
      } else {
        dispatch({
          type: "UPDATE_PROPERTY_RESALE_VIBE_STATUS_FAILED",
          payload: data,
        });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_PROPERTY_RESALE_VIBE_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};